export enum ESegmentUserTrait {
  SignupMethod = 'signupMethod',
  SignupVersion = 'signUpVersion',
  SignupStep = 'signUpStep',
  EmailScore = 'emailScore',
  Email = 'email',
  Country = 'country',
  DataCenter = 'dataCenter',
  Browser = 'browserAgent',
  FirstName = 'firstName',
  LastName = 'lastName',
  Language = 'language',
  Mobile = 'mobile',
  UserHash = 'user_hash',
  Title = 'title',
  Plan = 'plan',
  Avatar = 'avatar',
  Role = 'role',
  Currency = 'currency',
  RegistrationSource = 'registration_source',
  RegistrationCampaign = 'registration_campaign',
  RegistrationDevice = 'registration_device',
  AchievementsLevel = 'achievements_level',
  AppMode = 'app_mode',
  CreatedAt = 'createdAt',
  CompanyId = 'company_id',
  CompanyName = 'company_name',
  CompanyPlan = 'company_plan',
  CompanyCreatedAt = 'company_createdAt',
  OnboardingStep = 'onboardingStep',
  OnboardingChoice = 'onboardingChoice',
}

export enum ESegmentUTMParameter {
  UTMSource = 'utm_source',
  UTMMedium = 'utm_medium',
  UTMContent = 'utm_content',
  UTMCampaign = 'utm_campaign',
  UTMTerm = 'utm_term',
  Ref = 'ref',
  Hsfirstvisit = 'hsfirstvisit',
}

export enum ESegmentOnboardingChoice {
  Template = 'template',
  Upload = 'upload',
  Chat = 'chat',
  Dismiss = 'dismiss',
}

export enum ESegmentEvent {
  SignupLoaded = 'Signup Loaded',
  SignupInitiated = 'Signup Initiated',
  SignupFailed = 'Signup Failed',
  SignupBadEmail = 'Signup Bad Email',
  SignupLoadedStep2 = 'Signup Step 2 Loaded',
  SignupLoadedStep3 = 'Signup Step 3 Loaded',
  SignupCompleted = 'Signup Completed',
  OnboardingLoaded = 'Onboarding Loaded',
  OnboardingStep1 = 'Onboarding Step 1',
  SealedWithEditorPricingTable = 'Sealed With Editor PricingTable',
  SealedWithEditorForm = 'Sealed With Editor Form',
  SentSMS = 'sent-sms',
  AddedAttachment = 'added-attachment',
  SendManually = 'send-manually',
  AddedVideo = 'added-video',
  ChangeEmail = 'change-email',
  SaveDataProtection = 'save-data-protection',
  CreatedEmailTemplate = 'created-email_template',
  CreatedTag = 'created-tag',
  CreatedTeam = 'created-team',
  CreatedTheme = 'created-theme',
  CreatedUser = 'created-user',
  DownloadAllDocuments = 'download-all-documents',
  UploadedLogo = 'uploaded-logo',
  UploadedThumb = 'uploaded-thumb',
  CreatedTemplate = 'created-template',
  CreatedDocument = 'created-document',
}

export enum ESegmentIntegrationEvent {
  CreatedIntegrationAdroll = 'created-integration-adroll',
  CreatedIntegrationAdwords = 'created-integration-adwords',
  CreatedIntegrationApsislead = 'created-integration-apsislead',
  CreatedIntegrationAuthorizenet = 'created-integration-authorizenet',
  CreatedIntegrationBluesnap = 'created-integration-bluesnap',
  CreatedIntegrationCloseio = 'created-integration-closeio',
  CreatedIntegrationConversion = 'created-integration-conversion',
  CreatedIntegrationDocs = 'created-integration-docs',
  CreatedIntegrationDrive = 'created-integration-drive',
  CreatedIntegrationEmail = 'created-integration-email',
  CreatedIntegrationFacebook = 'created-integration-facebook',
  CreatedIntegrationFreshsales = 'created-integration-freshsales',
  CreatedIntegrationG2Crowd = 'created-integration-g2crowd',
  CreatedIntegrationGa = 'created-integration-ga',
  CreatedIntegrationGatv = 'created-integration-gatv',
  CreatedIntegrationHubspot = 'created-integration-hubspot',
  CreatedIntegrationHubspotsales = 'created-integration-hubspotsales',
  CreatedIntegrationLimecrm = 'created-integration-limecrm',
  CreatedIntegrationLinkedinsales = 'created-integration-linkedinsales',
  CreatedIntegrationMarketo = 'created-integration-marketo',
  CreatedIntegrationPardot = 'created-integration-pardot',
  CreatedIntegrationPerfectaudience = 'created-integration-perfectaudience',
  CreatedIntegrationPhone = 'created-integration-phone',
  CreatedIntegrationPipedrive = 'created-integration-pipedrive',
  CreatedIntegrationReco = 'created-integration-reco',
  CreatedIntegrationRecurly = 'created-integration-recurly',
  CreatedIntegrationSaml = 'created-integration-saml',
  CreatedIntegrationScim = 'created-integration-scim',
  CreatedIntegrationSlack = 'created-integration-slack',
  CreatedIntegrationStripe = 'created-integration-stripe',
  CreatedIntegrationSympa = 'created-integration-sympa',
  CreatedIntegrationTwitter = 'created-integration-twitter',
  CreatedIntegrationUpsales = 'created-integration-upsales',
  CreatedIntegrationZapier = 'created-integration-zapier',
}
